import tippy from 'tippy.js';
import { getBreakPoints as getBpoints, multilineEllipsis } from 'tbJSsrc/utils';

import news from './news/news';
import news_data from './news/data';
import util from './utils';

const cacheDomNodes = () => {
    const mainContentNode = document.getElementById('content-main');
    const headerNode = document.getElementById('header');
    const loginNode = document.getElementById('login-pane');
    const widgetNameDays = headerNode.querySelector('.col-nameday');
    const widgetWeather = headerNode.querySelector('.col-weather');
    const widgets = [
        widgetWeather.cloneNode(true),
        widgetNameDays.cloneNode(true),
    ];
    const todayContent = document.createElement('div');
    todayContent.className = 'col-xs-12 col-today';
    widgets.forEach((item) => {
        todayContent.append(item);
    });

    return { mainContentNode, loginNode, todayContent };
};

// Moving content elements in DOM for different breakpoints
const adjustStyle = (nodes, width) => {
    const { mainContentNode, loginNode, todayContent } = nodes;
    const hasPageTop = document.body.classList.contains('sbv2');
    const bPoints = getBpoints(hasPageTop ? 'sbv2' : undefined);

    if (width < bPoints.sm) {
        // Insert todayContent after the login block
        if (!mainContentNode.querySelector('.col-today')) {
            loginNode.parentNode.insertBefore(todayContent, loginNode.nextSibling);
        }

        // Multiline ellipsis for name days (due to lack of cross-browser support atm)
        const nameDaysBlock = todayContent.querySelector('.nav-namedays');
        if (nameDaysBlock) {
            nameDaysBlock.classList.remove('nav-namedays_ellipsis');
            multilineEllipsis(nameDaysBlock, 2);
            tippy('.nav-namedays', {
                // size: 'large', //todo no such size property anymore. check alternative
                theme: 'inbox'
            });
        }
    } else {
        const todayBlock = mainContentNode.querySelector('.col-today');
        if (todayBlock) {
            todayBlock.remove();
        }
    }
};

// Check user platform (Allows to target platform and use related fixes with css).
// Fixes font issue for News headers on windows (see _news.sass for css fix on class ".win")
if (navigator.platform.match('Win') !== null) {
    var topNews = document.getElementById("carousel_slider_top");
    var bottomNews = document.getElementById("carousel_slider_bottom");
    if (topNews) {
        topNews.className += " win";
    }
    if (bottomNews) {
        bottomNews.className += " win";
    }
}

// Scroll timer
var uniqueCntr = 0;
$.fn.scrolled = function (waitTime, fn) {
    if (typeof waitTime === "function") {
        fn = waitTime;
        waitTime = 500;
    }
    var tag = "scrollTimer" + uniqueCntr++;
    this.scroll(function () {
        var self = $(this);
        var timer = self.data(tag);
        if (timer) {
            clearTimeout(timer);
        }
        timer = setTimeout(function () {
            self.removeData(tag);
            fn.call(self[0]);
        }, waitTime);
        self.data(tag, timer);
    });
};

// This function is called from ADS system when a side banner is loaded
window.updateSideBannerDesign = function () {
    const cachedNodes = cacheDomNodes();

    function sideBanner(data) {
        if (typeof(data) === 'undefined') {
            return $("body").data('is_sb') || false;
        }
        $("body").data('is_sb', data);
    }

    function getLinkData(sliderSelector, dataItem) {
        return $(sliderSelector+' .main_news_categories .active .news_category_link').data(dataItem);
    }

    $(window).trigger('resize');

    // Sidebanner already  loaded
    if (sideBanner()) {
        return;
    }

    sideBanner(true);

    var currCategoryType = getLinkData('#carousel_slider_top', 'categorytype');
    var currCategoryChosen = getLinkData('#carousel_slider_top', 'filtercategory');
    var sourceId = news_data.getTopProvider();
    var categoryId = currCategoryChosen;

    // currCategoryType, sourceId, categoryId, currCategoryChosen, carouselToUpdateId
    news.updateSliderWithCategoryData(
        currCategoryType,
        sourceId,
        categoryId,
        currCategoryChosen,
        'carousel_slider_top'
    );

    currCategoryType = getLinkData('#carousel_slider_bottom', 'categorytype');
    currCategoryChosen = getLinkData('#carousel_slider_bottom', 'filtercategory');

    sourceId = (currCategoryChosen == news_data.categoryTop || typeof currCategoryChosen == "undefined") ? 0 : currCategoryChosen;
    categoryId = news_data.categoryTop;

    news.updateSliderWithCategoryData(
        currCategoryType,
        sourceId,
        categoryId,
        news_data.categoryTop,
        'carousel_slider_bottom'
    );

    adjustStyle(cachedNodes, window.innerWidth);
};

document.addEventListener("DOMContentLoaded", () => {
    const cachedNodes = cacheDomNodes();
    adjustStyle(cachedNodes, window.innerWidth);

    window.addEventListener('resize', () => {
        adjustStyle(cachedNodes, window.innerWidth);
    });

    util.reloadIfHttpsAvailable();
});
